export default "__VITE_ASSET__6979d782__"